<script>
import Message from './Message.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { Message, NextButton },
  emits: ['selectWhatsappTemplate'],
};
</script>

<template>
  <div class="p-5">
    <Message>Você só pode responder a esta conversa usando um</Message>
    <NextButton
      link
      blue
      class="!py-0 !px-0.5 text-base font-medium inline align-baseline"
      @click="$emit('selectWhatsappTemplate')"
    >
      modelo de mensagem
    </NextButton>
    <Message>devido a restrições de janela de mensagem de 24 horas.</Message>
  </div>
</template>
